import { render, staticRenderFns } from "./Movimientos.vue?vue&type=template&id=48898e9c&scoped=true"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"
import style0 from "./Movimientos.vue?vue&type=style&index=0&id=48898e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48898e9c",
  null
  
)

export default component.exports